import type { Describe, Struct } from 'superstruct';
import { array, integer, object, optional, string } from 'superstruct';

export interface ListResourceMetaDto {
	totalItems: number;
	itemsPerPage: number;
	page: number;
	timestamp?: string;
}

export interface ListResourceDto<T> {
	items: T[];
	meta: ListResourceMetaDto;
}

export function ListResourceDto<T>(
	struct: Struct<T>
): Describe<ListResourceDto<T>> {
	return object({
		items: array(struct),
		meta: object({
			totalItems: integer(),
			itemsPerPage: integer(),
			page: integer(),
			timestamp: optional(string()),
		}),
	});
}
